import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Header } from '../../layout';

const AccessoriesConfirmation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Get the state passed from the previous page
    const profileType = location.state?.profileType;
    const completedAccessory = location.state?.completedAccessory;
    const fromProfileConfiguration = location.state?.fromProfileConfiguration;

    // Normalize profile type to ensure it has the "N" prefix (only if profileType exists)
    const normalizedProfileType = profileType ? (profileType.startsWith('N') ? profileType : `N${profileType}`) : null;

    // Get accessory title for display
    const getAccessoryTitle = (accessoryType) => {
        switch (accessoryType) {
            case 'giunzioni':
                return 'Giunzioni';
            case 'corrimano':
                return 'Corrimano';
            case 'coprifilo':
                return 'Coprifilo';
            case 'led':
                return 'LED';
            case 'tappi':
                return 'Tappi NINFA';
            case 'spessori':
                return 'Spessori';
            default:
                return 'Accessorio';
        }
    };

    const handleMoreAccessories = () => {
        // Go back to accessories page with or without profile context
        navigate('/accessories', {
            state: {
                fromProfileConfiguration: fromProfileConfiguration || false,
                profileType: normalizedProfileType
            }
        });
    };

    const handleGoToCart = () => {
        // Go to order summary (cart)
        navigate('/order-summary');
    };

    return (
        <div className="min-h-screen bg-gray-100">
            <Header title="Accessori Configurati" />

            <div className="container mx-auto px-4 py-8">
                <div className="max-w-md mx-auto bg-white rounded-lg shadow p-6">
                    <div className="text-center">
                        {/* Success icon */}
                        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>

                        <h2 className="text-xl font-semibold mb-2">
                            Accessorio Aggiunto!
                        </h2>

                        <p className="text-gray-600 mb-6">
                            {completedAccessory && (
                                <>
                                    <strong>{getAccessoryTitle(completedAccessory)}</strong> è stato aggiunto al tuo ordine{normalizedProfileType ? ` per il profilo ` : ''}{normalizedProfileType ? <strong>{normalizedProfileType}</strong> : ''}.
                                    <br /><br />
                                </>
                            )}
                            Vuoi configurare altri accessori{normalizedProfileType ? ' compatibili' : ''}?
                        </p>

                        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                            <p className="text-sm text-red-800">
                                {normalizedProfileType ? (
                                    <>Puoi continuare ad aggiungere accessori compatibili con il tuo profilo <strong>{normalizedProfileType}</strong> o procedere al carrello per completare l'ordine.</>
                                ) : (
                                    <>Puoi continuare ad aggiungere altri accessori o procedere al carrello per completare l'ordine.</>
                                )}
                            </p>
                        </div>

                        <div className="space-y-3">
                            <button
                                onClick={handleMoreAccessories}
                                className="w-full px-6 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
                            >
                                Sì, aggiungi altri accessori
                            </button>

                            <button
                                onClick={handleGoToCart}
                                className="w-full px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
                            >
                                No, vai al carrello
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessoriesConfirmation;